// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"ConfirmationDialog_secondaryButton__Cwy9L"};